// extracted by mini-css-extract-plugin
export default {"aside":"AsideInstrucciones_aside__O5ZVH","list_instrucciones":"AsideInstrucciones_list_instrucciones__tvA7S"};